import { customScrollMinimal, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Separator = styled.div`
  width: 100%;
  display: flex;
  gap: 12px;
`;

export const LeftContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const ScrollableContainer = styled.div`
  flex: 1;
  max-height: 100vh;
  overflow-y: auto;
  scroll-behavior: smooth;
  width: 100%;
  ${customScrollMinimal};
`;

export const Title = styled.p`
  color: var(--text-default);
  margin-top: 24px;
  ${typographyV2.titleLg};
`;
